import { TRequiresTimeChange } from '@/types/session.types';
import { getDaysHoursMinsFromDateNumeric } from './get-days-hours-mins-from-date';
import { isDateTodayInTimeZone } from './is-date-today-in-timezone';
import { isStartDateNotSet } from './is-start-date-not-set';
import timezoneMap from '../timezone-short-name-map.json' with { type: 'json' };

export const getFirstPossibleCalcMinutes = (
  isEnd: boolean,
  isStartAndEndSameDay: boolean,
  startDateNumeric: number,
  millisecondsTimezoneOffset: number,
  requiresTimeChange: TRequiresTimeChange | null | undefined,
  generatedOptionIncrementMinutes: number,
  timeZone: keyof typeof timezoneMap
): number => {
  const startDateNumberStats = getDaysHoursMinsFromDateNumeric(startDateNumeric + millisecondsTimezoneOffset);

  if (isEnd) {
    if (isStartAndEndSameDay) {
      // minutes in to the day of the startDate
      return startDateNumberStats.hours * 60 + startDateNumberStats.minutes;
    } else {
      // the earliest minutes in to the day based on generatedOptionIncrementMinutes
      // if start minutes = 15 and generatedOptionIncrementMintues = 30 we will return 15 + 30 % 30 => 15
      // if start minutes = 45 and generatedOptionIncrementMintues = 30 we will return 45 + 30 % 30 => 15
      return (startDateNumberStats.minutes + generatedOptionIncrementMinutes) % generatedOptionIncrementMinutes;
    }
  } else {
    if (isDateTodayInTimeZone(startDateNumeric, timeZone) && isStartDateNotSet(requiresTimeChange)) {
      // minutes in to the day of the startDate
      return startDateNumberStats.hours * 60 + startDateNumberStats.minutes;
    } else {
      // first minute of the day
      return 0;
    }
  }
};
